import { Mutation, Action, Getter, HasGetter, extractVuexModule, VuexClass } from 'vuex-class-module';

@VuexClass({
  modules: {}
})
class AppState {
  currentArea: string = 'default';
  @HasGetter 
  gasDate: Date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

  @HasGetter
  entityType: string = '';

  @HasGetter
  referenceId: string = '';

  @HasGetter
  activePanel: string = '';

  @HasGetter
  showFacilityType: any = { 
    showPipe: true,
    showProduction: true,
    showStorage: true,
    showGateStation: true,
    showCompressor: true,
    showGpg: true,
    showHub: true
  };

  @HasGetter
  reportFacilities: Array<number> = []; 
  
  @HasGetter
  reportStates: Array<number> = []; 

  @HasGetter
  reportParticipants: Array<number> = []; 

  @Getter 
  getArea(state) {
    return state.currentArea;
  }

  @Mutation
  setArea(state, area) {
    return state.currentArea = area;
  }

  @Mutation
  setGasDate(state, date) {
    state.gasDate = date;
  }

  @Mutation
  setEntityType(state, entityType) {
    state.entityType = entityType;
  }

  @Mutation
  setReferenceId(state, referenceId) {
    state.referenceId = referenceId;
  }

  @Mutation
  unsetEntityType(state) {
    state.entityType = '';
  }

  @Mutation
  unsetReferenceId(state) {
    state.referenceId = '';
  }

  @Mutation
  setActivePanel(state, panel) {
    state.activePanel = panel;
  }

  @Mutation
  setReportFacilities(state, facilities) {
    state.reportFacilities = facilities;
  }

  @Mutation
  setReportStates(state, states) {
    state.reportStates = states;
  }

  @Mutation
  setReportParticipants(state, participants) {
    state.reportParticipants = participants;
  }
  
  @Mutation
  setShowFacilityType(state, payload) {
    let facilityType = payload.facilityType;
    let show = payload.show;
    switch (facilityType) {
      case "PIPE":
        state.showFacilityType.showPipe = show;
        break;
      case "STOR":
        state.showFacilityType.showStorage = show;
        break;
      case "PROD":
        state.showFacilityType.showProduction = show;
        break;
      case "GPG":
        state.showFacilityType.showGpg = show;
        break;
      case "COMPRESSOR":
        state.showFacilityType.showCompressor = show;
        break;
      case "GATESTATION":
        state.showFacilityType.showGateStation = show;
        break;
      case "HUB":
        state.showFacilityType.showHub = show;
        break;
      default:
        break;
    }
  }
}

const appStateModule = extractVuexModule(AppState);

export default appStateModule;



// WEBPACK FOOTER //
// src/store/modules/app-state.ts